import { LocaleContext } from '@/providers/locale-provider'
import { Question } from '@/types/questions'
import { InfoModal, RichText } from '@lib-components'
import { Dispatch, ReactElement, SetStateAction, use } from 'react'

type Props = {
    question: Question
    isInfoModalVisible: boolean
    setInfoModalVisibility: Dispatch<SetStateAction<boolean>>
}

export const AdditionalQuestionInformation = ({
    question,
    isInfoModalVisible,
    setInfoModalVisibility,
}: Props): ReactElement => {
    const localeContext = use(LocaleContext)

    return (
        <>
            {question.additionalInformation && (
                <InfoModal
                    isModalVisible={isInfoModalVisible}
                    setModalVisibility={setInfoModalVisibility}
                    title={localeContext.getLocaleText(question.additionalInformation.title)}
                >
                    <RichText rawHtml={localeContext.getLocaleText(question.additionalInformation.description)} />
                </InfoModal>
            )}
        </>
    )
}
